import {
  useSwrApi,
  ApiUserSubscriptionInfoOk,
  ApiUserSubscriptionList,
} from '@hooks/useSwrApi';


// Interface
// *****************************************************
interface UseSwrUserSubscriptionList {
  locale?: string,
  serverSideData?: ApiUserSubscriptionList,
  shouldFetch?: boolean,
}


/**
 * @description SWR: fetch user subscription list.
 * - **locale** - the locale to use for the request.
 * - **serverSideData** - the data we got from the server side request (if we do it).
 * - **shouldFetch** - condition for fetching the data.
 */
export const useSwrUserSubscriptionList = (props: UseSwrUserSubscriptionList) => {
  // Destructure props
  const {
    locale = 'ro',
    serverSideData,
    shouldFetch = true,
  } = props;

  // Get data from API
  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiUserSubscriptionInfoOk>({
    url: '/v1/user-subscription/list',
    locale,
    serverSideData,
    shouldFetch,
    apiOptions: {
      revalidateOnFocus: false,
    },
  });

  // Return data
  // ********************************************
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
